import React, { useState } from 'react';
import Select from '../../Select';
const YearDropdown = ({ currentYear, minYear, maxYear, changeYear, }) => {
    const options = [];
    const [selectedOption, setSelectedOption] = useState(currentYear);
    let currentOption = null;
    for (let i = minYear; i <= maxYear; i++) {
        const val = String(i);
        const option = { name: val, value: val };
        options.push(option);
        if (i === currentYear) {
            currentOption = option;
        }
    }
    const handlechange = (value) => {
        changeYear(+value.value);
        setSelectedOption(+value.value);
    };
    return (React.createElement(Select, { defaultOption: false, height: 2, width: 4, label: `Choose Year, ${selectedOption}`, onChange: (value) => handlechange(value), options: options, selectedOption: currentOption }));
};
export default YearDropdown;
